import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { Block } from './Block';

export const RepostPreviewBlock = styled(Block).attrs({
  className: createReadableClass({
    component: 'repost-preview-block'
  })
})``;
